import { FC } from 'react';
import { Form } from 'antd';
import { FormItemProps } from 'antd/lib/form';
import { useField, FieldHookConfig } from 'formik';
import { RichTextEditorLazy } from './rich-text-editor-lazy';

export type RichTextFieldProps = FieldHookConfig<string> & {
  item?: FormItemProps;
};

export const RichTextField: FC<RichTextFieldProps> = ({ item, ...props }) => {
  const [field, meta, helpers] = useField(props);

  return (
    <Form.Item {...item} validateStatus={meta.touched && !!meta.error ? 'error' : undefined} help={meta.touched ? meta.error : undefined}>
      <RichTextEditorLazy
        data={field.value ?? ''}
        onChange={(_event: any, editor: any) => {
          helpers.setValue(editor.getData());
        }}
        onBlur={() => helpers.setTouched(true)}
      />
    </Form.Item>
  );
};
